import { render, staticRenderFns } from "./AdminTree.vue?vue&type=template&id=631c49ea&scoped=true&"
import script from "./AdminTree.vue?vue&type=script&lang=js&"
export * from "./AdminTree.vue?vue&type=script&lang=js&"
import style0 from "./AdminTree.vue?vue&type=style&index=0&id=631c49ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631c49ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer})
